// features/api/connectionApi.js
import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const connectionApi = createApi({
  reducerPath: 'connectionApi',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['Connections'],
  endpoints: (builder) => ({
    getAllConnections: builder.query({
      query: ({ page = 0, limit = 10 }) => ({
        url: `admin/connections?page=${page + 1}&limit=${limit}`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }),
      transformResponse: (res) => res || [],
      providesTags: ['Connections'],
    }),
  }),
});

export const {
  useGetAllConnectionsQuery,
} = connectionApi;
